import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	danger: {
		color: colors.red[400]
	},
	iconButton: {
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent")
		}
	}
})

export default useStyles
